/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'
import ReactPaginate from 'react-paginate'

import Menu from '../../../../components/Peyks/Menu'

import Table from '../../../../components/Peyks/PeyksList'

import { useNavigate } from 'react-router-dom'

import peykIcon from '../../../../assets/svg/PMotorCycle.svg'

import { get } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

export default function index() {
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate()

  document.title = 'پیک‌ها'
  const [peyks, setPeyks] = useState()
  const [peyksCount, setPeyksCount] = useState()
  const [totalPage, setTotalPage] = useState()
  

  const token = localStorage.getItem('token')

  const navigateHandler = () => {
    navigate('/peyk/peyks/create')
  }

  const handlePageClick = (event) => {
    get(`/api/admin/peyks?page=${event.selected + 1}&token=${token}`)
      .then(respose => {
        setPeyks(respose.data.data.docs)
        setTotalPage(respose.data.data.pages)
        setPeyksCount(respose.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }

  useEffect(() => {
    get(`/api/admin/peyks?token=${token}`)
      .then(respose => {
        console.log(respose)
        setPeyks(respose.data.data.docs)
        setTotalPage(respose.data.data.pages)
        setPeyksCount(respose.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token, totalPage])

  return (
    <main id='panel'>
      <Menu page={'peyks'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={peykIcon} width={30} alt='resturantIcon' />
              </div>
              <div className='text'>
                لیست پیک‌ها
              </div>
            </div>

            <div className="left">
              <button onClick={navigateHandler}>ایجاد پیک جدید</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد پیک‌ها
              </div>
              <div className="left">
                {peyksCount}
              </div>
            </div>

            <Table data={peyks} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>
          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
